import "./styles/main.scss";

const lazyInit = (selector, loader, rootMargin = "200px") => {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loader();
          obs.disconnect();
        }
      });
    },
    { rootMargin },
  );

  elements.forEach((el) => observer.observe(el));
};

lazyInit(".header", () =>
  import("./js/navigation.js").then((module) => module.initializeNavigation()),
);

lazyInit("[data-search-field]", () =>
  import("./js/search-field.js").then((module) => module.initializeSearchFields()),
);

lazyInit(".home-projects--animate", () =>
  import("./js/home-projects.js").then((module) => module.initializeHomeProjects()),
);

lazyInit(".home-jobs--animate", () =>
  import("./js/home-jobs.js").then((module) => module.initializeHomeJobs()),
);

lazyInit(".research-record, .text-image-vertical__media-youtube, .news-media__youtube, .news-media__file", () =>
  import("./js/research-record.js").then((module) => module.initializeResearchRecord()),
);

lazyInit(".news-share", () =>
  import("./js/news-share.js").then((module) => module.initializeNewsShare()),
);

lazyInit(".research-team", () =>
  import("./js/research-team.js").then((module) => module.initializeResearchTeam()),
);

lazyInit(".research-research-teams--animate", () =>
  import("./js/research-research-teams.js").then((module) =>
    module.initializeResearchResearchTeams(),
  ),
);

lazyInit("[data-contact-form]", () =>
  import("./js/contact-form.js").then((module) => module.initializeContactForm()),
);
